import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {contentFeedItemsApi} from 'common/src/modules/contentFeedItems/contentFeedItems.api';
import {loadDraftItems} from './loadDraftItems.thunk';

export const deleteDraftItems = createAsyncThunk(
  `${BreadcrumbName.ContentFeedPage}/deleteDraftItems`,
  async ({feedId, itemIds}: {feedId: number; itemIds: number[]}, {dispatch}) => {
    const uniqueIds = [...new Set(itemIds)];

    await Promise.all(uniqueIds.map((itemId) => contentFeedItemsApi.deleteDraftItem(feedId, itemId)));
    await dispatch(loadDraftItems({feedId, forceReload: true})).unwrap();
  },
);
